import { CASH_MOVEMENT_TYPES } from '../../../constants'

export enum MovementVariant {
  Remove = 'remove',
  Add = 'add',
}

export interface Movement {
  amount: number
  date: string
  id: string
  note?: string
  register_id: string | null
  register_open_sequence_id: string
  type: CASH_MOVEMENT_TYPES
  user: {
    id: string
    name: string
  } | null
  user_id: string
}

export interface CashFloatSettings {
  amount: string
  note: string
  type: CASH_MOVEMENT_TYPES
}
